import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';

import { Box, Flex, Icon, Select, Text } from 'core/components';
import { showSuccessToast } from 'core/components/toast';

const NO_SCOPE_VALUE = '';
const NO_SCOPE_LABEL = 'All';

// The navbar is always dark, so the pill is styled against that background rather than the theme.
const PillWrapper = styled(Box)`
  .bp4-button {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    min-height: 30px;
    padding: 0 6px 0 12px;
    border: none;
    border-radius: 999px;
    background-image: none;
    box-shadow: none;
    background-color: ${({ $on, theme }) => ($on ? theme.colors.kentik : 'rgba(255, 255, 255, 0.08)')};

    &:hover,
    &.bp4-active {
      background-image: none;
      box-shadow: none;
      background-color: ${({ $on, theme }) => ($on ? theme.colors.kentik : 'rgba(255, 255, 255, 0.16)')};
      filter: ${({ $on }) => ($on ? 'brightness(1.1)' : 'none')};
    }

    .bp4-icon {
      color: #fff !important;
      fill: #fff !important;
    }
  }
`;

/**
 * TEMPORARY: exercises the ephemeral active-scope selection end to end. The selection is written
 * to the server session, not to the user record, so nothing about it appears in later request
 * URLs - which is why the change has to be fanned out explicitly to refetch.
 */
@inject('$auth', '$globalFilters')
@observer
class ActiveScopeSelector extends Component {
  handleChange = (value) => {
    const { $globalFilters } = this.props;
    const scopeId = value === NO_SCOPE_VALUE ? null : value;

    if (scopeId === $globalFilters.activeScopeId) {
      return;
    }

    $globalFilters.selectActiveScope(scopeId).then(({ scope, generation }) => {
      // Temporary visibility into the fan-out until real consumers register handlers.
      showSuccessToast(
        `Global filter ${scope ? `"${scope.name}"` : 'cleared'} - notified ${
          $globalFilters.scopeChangeHandlers.size
        } listener(s), generation ${generation}`
      );
    });
  };

  valueRenderer = () => {
    const { $globalFilters } = this.props;
    const { activeScope } = $globalFilters;

    return (
      <Flex alignItems="center" gap="6px" maxWidth={180}>
        <Icon icon="filter" iconSize={13} />
        <Text color="#fff" fontWeight="bold" fontSize="13px" ellipsis>
          {activeScope ? activeScope.name : NO_SCOPE_LABEL}
        </Text>
      </Flex>
    );
  };

  render() {
    const { $auth, $globalFilters } = this.props;
    const { activeScopeId, activeScopeLoading, activeScopeOptions } = $globalFilters;

    if (!$auth.hasPermission('globalFilters.enabled', { overrideForSudo: false })) {
      return null;
    }

    return (
      <PillWrapper $on={!!activeScopeId}>
        <Select
          options={[{ label: NO_SCOPE_LABEL, value: NO_SCOPE_VALUE }, ...activeScopeOptions]}
          values={activeScopeId ?? NO_SCOPE_VALUE}
          onChange={this.handleChange}
          valueRenderer={this.valueRenderer}
          loading={activeScopeLoading}
          ariaLabel="Global Filter"
          buttonStyle={{ rightIcon: 'caret-down', iconSize: 14 }}
          width="auto"
          menuWidth={240}
          small
        />
      </PillWrapper>
    );
  }
}

export default ActiveScopeSelector;
